var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-one-column",class:_vm.classes},[_c('div',{staticClass:"text-one-column-richtext"},[_vm._t("default")],2),_c('KfButtonContainer',{attrs:{"button-container-links":_vm.links,"button-container-position-horizontal":_vm.btnAlignmentHorizontal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }